(function(){
'use strict';

const SHEEP = [
  {
    id:"delilah", name:"Delilah", nickname:"“The Alpha”",
    url:"https://sheepylife.com/bracelets/p/delilah",
    blurb:"You're the watchful, feisty guardian of your group. Delilah is always on duty, protecting her flock without hesitation \u2014 tough on the outside, soft-hearted underneath. She's a Finnsheep/Shetland cross with five natural wool colors and an unforgettable face.",
    traits:["Protective","Feisty","Loyal"],
    v:{B:3,A:1,P:1,C:1,Ca:1}
  },
  {
    id:"valkia", name:"Valkia", nickname:"“The Gentle Giant”",
    url:"https://sheepylife.com/bracelets/p/valkia",
    blurb:"Sweet, sensitive, and a little bit royal \u2014 you're first in line for affection and never shy about asking for it. Valkia is the princess of her flock, devoted to her shepherd, and just as likely to be silly as she is to be proper.",
    traits:["Affectionate","Devoted","Playful"],
    v:{B:1,A:3,P:2,C:1,Ca:2}
  },
  {
    id:"fiona", name:"Fiona", nickname:"“Old Faithful”",
    url:"https://sheepylife.com/bracelets/p/fiona",
    blurb:"Calm, steady, and easy to be around \u2014 you find joy in the simple things. Fiona loves nothing more than sitting close to her shepherdess for scratches, often dozing off mid-cuddle. Stable, loving, unbothered.",
    traits:["Calm","Loving","Easygoing"],
    v:{B:0,A:2,P:1,C:1,Ca:3}
  },
  {
    id:"eddie", name:"Eddie", nickname:"The Curious One",
    url:"https://sheepylife.com/bracelets/p/eddie",
    blurb:"A little reserved at first, but young at heart once you warm up. Eddie can't resist a good run with the lambs, has a distinctive Gray Katmoget coat, and a soft spot for zucchini.",
    traits:["Shy at first","Curious","Playful"],
    v:{B:0,A:1,P:2,C:2,Ca:2}
  },
  {
    id:"apricot", name:"Apricot", nickname:"Little Miss Apricot",
    url:"https://sheepylife.com/bracelets/p/apricot",
    blurb:"Sweet, curious, and always keeping an eye on what everyone else is doing. Apricot tilts her head at every little mystery, has her own peculiar habits, and gets a bit anxious if she thinks she's missing out on snacks.",
    traits:["Curious","Watchful","Sweet"],
    v:{B:0,A:2,P:1,C:3,Ca:1}
  },
  {
    id:"gustave", name:"Gustave", nickname:"“Gusto Man”",
    url:"https://sheepylife.com/bracelets/p/gustave",
    blurb:"Clever, social, and always scheming your next adventure. Gustave is forever on the lookout for mischief \u2014 sneaking through fences, following people around for pets, or getting into something with his brother.",
    traits:["Clever","Mischievous","Social"],
    v:{B:1,A:1,P:2,C:3,Ca:0}
  },
  {
    id:"paula", name:"Paula", nickname:"The Original",
    url:"https://sheepylife.com/bracelets/p/paula",
    blurb:"Sweet, inquisitive, and the first to check out anything new \u2014 you've got a lot to say and you're not afraid to say it. Paula is one of the original members of her flock, with the most recognizable baa on the whole farm.",
    traits:["Inquisitive","Vocal","Protective"],
    v:{B:2,A:2,P:1,C:2,Ca:1}
  },
  {
    id:"padraic", name:"Padraic", nickname:"\u201cPaw-rick\u201d",
    url:"https://sheepylife.com/bracelets/p/padraic",
    blurb:"Pure energy \u2014 you're the one jumping for joy on your way to wherever you're headed next. Padraic sprints to and from the pasture just because he can, and never misses a chance for a burdock leaf or a piece of zucchini.",
    traits:["Energetic","Joyful","Spirited"],
    v:{B:0,A:1,P:3,C:1,Ca:0}
  },
  {
    id:"mooskit", name:"Mooskit", nickname:"The Softie",
    url:"https://sheepylife.com/bracelets/p/mooskit",
    blurb:"Shy at first, but once you let someone in, you're more like a devoted dog than anything else. Mooskit is one of the smallest in the flock, lives for a forehead scratch, and warms up slowly but completely.",
    traits:["Shy at first","Devoted","Gentle"],
    v:{B:0,A:3,P:1,C:0,Ca:2}
  },
  {
    id:"mickey", name:"Mickey", nickname:"\u201cMickey Finn\u201d",
    url:"https://sheepylife.com/bracelets/p/mickey",
    blurb:"Affectionate through and through \u2014 you're the first to greet someone you love and the last to stop asking for a back rub. Mickey's been sweet and cuddly since day one, and age has only made him more of a gentleman.",
    traits:["Affectionate","Loyal","Warm"],
    v:{B:0,A:3,P:0,C:0,Ca:3}
  },
  {
    id:"princecharlie", name:"Prince Charlie", nickname:"The House Parent",
    url:"https://sheepylife.com/bracelets/p/princecharlie",
    blurb:"Calm, dignified, and quietly in charge \u2014 people (and sheep) respect you without you having to ask. Charlie is the mature ram of his flock, well-mannered and steady, and doesn't tolerate much in the way of shenanigans.",
    traits:["Composed","Dignified","Steady"],
    v:{B:2,A:1,P:0,C:0,Ca:3}
  },
  {
    id:"magnolia", name:"Magnolia", nickname:"The Sweetheart",
    url:"https://sheepylife.com/bracelets/p/magnolia",
    blurb:"Sweet and simple, you're always one of the first to come looking for affection \u2014 nose to nose, big loving eyes and all. Magnolia is a calm, gentle blend of Finnsheep and Shetland, though she's not above a little mischief, like sneaking a bite from the dog's bowl when no one's looking.",
    traits:["Affectionate","Gentle","A little mischievous"],
    v:{B:0,A:3,P:0,C:2,Ca:2}
  },
  {
    id:"norma", name:"Norma", nickname:"The Black Sheep",
    url:"https://sheepylife.com/bracelets/p/norma",
    blurb:"You're the wild and wonderful one \u2014 a little dramatic, a lot of heart. Norma is a small but stout-hearted Shetland who's not to be messed with, always ready to jump up for a snack, and just as happy dozing off mid-scratch, dreaming away.",
    traits:["Dramatic","Spirited","Tenacious"],
    v:{B:2,A:2,P:3,C:1,Ca:1}
  }
];

const QUESTIONS = [
  {q:"A friend cancels plans last minute. You:", opts:[
    {t:"Say something \u2014 you don't let things slide", dim:"B"},
    {t:"Feel a little hurt but check in on them anyway", dim:"A"},
    {t:"Shrug and go find something more fun to do", dim:"P"},
    {t:"Are secretly relieved \u2014 more time to yourself", dim:"Ca"}
  ]},
  {q:"Your ideal Saturday morning looks like:", opts:[
    {t:"Sleeping in, then a slow, quiet start", dim:"Ca"},
    {t:"Cuddled up with someone you love", dim:"A"},
    {t:"Already out the door, chasing an idea", dim:"P"},
    {t:"Poking around somewhere new before anyone's awake", dim:"C"}
  ]},
  {q:"In a group project, you're usually the one who:", opts:[
    {t:"Takes charge and makes sure it gets done", dim:"B"},
    {t:"Asks a hundred questions nobody thought to ask", dim:"C"},
    {t:"Keeps the energy and momentum going", dim:"P"},
    {t:"Quietly makes sure everyone's doing okay", dim:"A"}
  ]},
  {q:"Someone you just met seems a little standoffish. You:", opts:[
    {t:"Give them space \u2014 they'll come around when ready", dim:"Ca"},
    {t:"Take it as a challenge to win them over", dim:"P"},
    {t:"Get curious about what's going on with them", dim:"C"},
    {t:"Warm up to them slowly, then completely", dim:"A"}
  ]},
  {q:"Your snack instincts:", opts:[
    {t:"Snacks are serious business \u2014 don't leave me out", dim:"C"},
    {t:"First in line, every time", dim:"A"},
    {t:"Whatever's fastest so I can get back to what I was doing", dim:"P"},
    {t:"I'll get to it eventually, no rush", dim:"Ca"}
  ]},
  {q:"When something threatens someone you care about, you:", opts:[
    {t:"Step in front of it without a second thought", dim:"B"},
    {t:"Stay close and keep watch", dim:"A"},
    {t:"Investigate before reacting", dim:"C"},
    {t:"Trust it'll sort itself out", dim:"Ca"}
  ]},
  {q:"Your friends would describe your energy as:", opts:[
    {t:"Unstoppable", dim:"P"},
    {t:"Grounding", dim:"Ca"},
    {t:"Warm", dim:"A"},
    {t:"Unpredictable, in a good way", dim:"C"}
  ]},
  {q:"A new gadget shows up in the house. You:", opts:[
    {t:"Have to figure out how it works immediately", dim:"C"},
    {t:"Let someone else deal with it", dim:"Ca"},
    {t:"Get way too excited about it", dim:"P"},
    {t:"Only care if it means more time with people you like", dim:"A"}
  ]},
  {q:"How do you handle being told what to do?", opts:[
    {t:"I push back if I don't agree", dim:"B"},
    {t:"Depends who's asking and why", dim:"C"},
    {t:"I go along with it \u2014 not worth the fuss", dim:"Ca"},
    {t:"I just want to make the person happy", dim:"A"}
  ]},
  {q:"Your idea of a perfect vacation:", opts:[
    {t:"Nonstop activities, new places every day", dim:"P"},
    {t:"Somewhere quiet with nothing on the schedule", dim:"Ca"},
    {t:"Somewhere I've never been, just to see it", dim:"C"},
    {t:"Anywhere, as long as it's with the right people", dim:"A"}
  ]},
  {q:"When you walk into a room, people notice because:", opts:[
    {t:"You've got presence \u2014 people just listen", dim:"B"},
    {t:"You're already laughing about something", dim:"P"},
    {t:"You're asking someone an odd, specific question", dim:"C"},
    {t:"You're hugging someone before you even say hi", dim:"A"}
  ]},
  {q:"Your relationship with rules:", opts:[
    {t:"I set them \u2014 someone has to", dim:"B"},
    {t:"I follow them, mostly out of habit", dim:"Ca"},
    {t:"I like knowing exactly why they exist", dim:"C"},
    {t:"I'll bend them if it makes someone's day better", dim:"A"}
  ]},
  {q:"You just found out something surprising. First move:", opts:[
    {t:"Ask twelve follow-up questions", dim:"C"},
    {t:"React loudly, then move on fast", dim:"P"},
    {t:"Sit with it for a while before saying anything", dim:"Ca"},
    {t:"Immediately want to tell someone you trust", dim:"A"}
  ]},
  {q:"At a party, you're most likely to be found:", opts:[
    {t:"Running the games, keeping things lively", dim:"P"},
    {t:"Deep in conversation with one or two people", dim:"A"},
    {t:"Near the door, sizing up who's here", dim:"B"},
    {t:"Somewhere quiet, watching everyone else have fun", dim:"Ca"}
  ]},
  {q:"If someone challenged you to a staring contest, you'd:", opts:[
    {t:"Win. Obviously.", dim:"B"},
    {t:"Laugh and lose on purpose", dim:"P"},
    {t:"Get distracted wondering why they suggested it", dim:"C"},
    {t:"Not even flinch \u2014 you're unbothered", dim:"Ca"}
  ]}
];

let current = 0;
let scores = {B:0,A:0,P:0,C:0,Ca:0};
let card;
let fence;

function initializeSheepyQuiz(scope){
  const quiz = (scope || document).querySelector('#sheepy-life-quiz');
  if(!quiz) return;
  card = quiz.querySelector('#card');
  fence = quiz.querySelector('#fence');
  if(!card || !fence) return;
  if(!quiz.dataset.sheepyQuizReady){
    quiz.dataset.sheepyQuizReady = 'true';
    quiz.addEventListener('click', function(event){
      const startButton = event.target.closest('[data-sheepy-action="start"]');
      const restartButton = event.target.closest('[data-sheepy-action="restart"]');
      const optionButton = event.target.closest('[data-sheepy-dim]');

      if(startButton) startQuiz();
      if(restartButton) renderIntro();
      if(optionButton) answer(optionButton.dataset.sheepyDim);
    });
  }
  renderIntro();
}

function buildFence(){
  fence.innerHTML = '';
  for(let i=0;i<QUESTIONS.length;i++){
    const post = document.createElement('div');
    post.className = 'post';
    if(i < current) post.classList.add('done');
    if(i === current) post.classList.add('current');
    fence.appendChild(post);
  }
}

function renderIntro(){
  fence.style.display = 'none';
  card.innerHTML = `
    <div class="intro">
      <p>Fifteen quick questions about how you move through the world \u2014 no wrong answers, just wool. At the end, you'll meet the Sheepy Life sheep whose personality is most like yours.</p>
      <button class="startbtn" type="button" data-sheepy-action="start">Start the Quiz →</button>
    </div>`;
}

function startQuiz(){
  current = 0;
  scores = {B:0,A:0,P:0,C:0,Ca:0};
  fence.style.display = 'flex';
  renderQuestion();
}

function renderQuestion(){
  buildFence();
  const item = QUESTIONS[current];
  card.innerHTML = `
    <div class="qnum">Question ${current+1} of ${QUESTIONS.length}</div>
    <p class="qtext">${item.q}</p>
    <div class="options">
      ${item.opts.map(o => `<button class="opt" type="button" data-sheepy-dim="${o.dim}">${o.t}</button>`).join('')}
    </div>`;
}

function answer(dim){
  scores[dim] += 1;
  current++;
  if(current < QUESTIONS.length){
    renderQuestion();
  } else {
    showResult();
  }
}

function showResult(){
  fence.style.display = 'none';
  let best = null, bestScore = -Infinity;
  SHEEP.forEach(s => {
    let dot = 0;
    for(const k in scores){ dot += scores[k] * s.v[k]; }
    if(dot > bestScore){ bestScore = dot; best = s; }
  });

  card.innerHTML = `
    <div class="result">
      <div class="tag">You're most like</div>
      <h2>${best.name}</h2>
      <p class="nickname">${best.nickname}</p>
      <div class="blurb">${best.blurb}</div>
      <div class="traits">${best.traits.map(t => `<span class="pill">${t}</span>`).join('')}</div>
      <div class="actions">
        <a class="cta" href="${best.url}" target="_top">Meet ${best.name} &amp; Shop Their Bracelet →</a>
        <button class="restartbtn" type="button" data-sheepy-action="restart">Take It Again</button>
      </div>
    </div>`;
}

initializeSheepyQuiz(document);

document.addEventListener('shopify:section:load', function(event){
  initializeSheepyQuiz(event.target);
});

})();